const splitToParagraphs = (text) => text
    .replace(/\r/g, '\n')
    .split('\n')
    .filter((paragraph) => paragraph.length > 0);

export { splitToParagraphs };
//# sourceMappingURL=splitToParagraphs.js.map
